import { useThemeMode } from '@/contexts/ThemeModeContext';

/** Fade incompatible connection targets toward the canvas rather than black in light mode. */
export function useObscuredNodeFilter() {
  return useThemeMode() === 'light' ? 'opacity(0.4)' : 'brightness(0.4)';
}
